import { MessageSquare } from 'lucide-react';

import { cn } from '@dashai/lib/utils';

interface QuestionsTabProps {
  open: boolean;
  onToggle: () => void;
  className?: string;
}

/** The vertical "Questions?" launcher on the right edge of a dashboard. */
export function QuestionsTab({ open, onToggle, className }: QuestionsTabProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={open}
      aria-label={open ? 'Close questions panel' : 'Open questions panel'}
      className={cn(
        'absolute top-[36%] z-30 flex rotate-180 items-center gap-2 rounded-r-lg bg-topbar px-2 py-4',
        'text-xs font-semibold tracking-wide text-topbar-foreground shadow-md [writing-mode:vertical-rl]',
        'transition-colors hover:brightness-125 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        className,
      )}
    >
      <MessageSquare className="h-3.5 w-3.5 rotate-90" aria-hidden="true" />
      Questions?
    </button>
  );
}
